import { useContext } from 'react';

import { ApplicationContext } from '../../../../../shared/source/context/context';
import { SkillChip } from '../../../design/components/skillChips/SkillChip';

import type { ChipPropType } from '../../../design/components/skillChips/SkillChip';
import type { ChipProps } from '@mui/material/Chip';
import type { FunctionComponent, MouseEventHandler } from 'react';

type SkillChipWithDrawerProps = Pick<ChipProps, 'size' | 'variant'> & {
    readonly isDisabled?: boolean | undefined;
    readonly label: string;
    readonly showAddIcon?: boolean;
    readonly skillId: string;
    readonly type?: ChipPropType;
};

export const SkillChipWithDrawer: FunctionComponent<SkillChipWithDrawerProps> = (props) => {
    const { actions } = useContext(ApplicationContext);

    const handleClick: MouseEventHandler = (e): void => {
        e.preventDefault();
        e.stopPropagation();

        actions.openSkillDetails(props.skillId);
    };

    return (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <SkillChip {...props} onClick={handleClick} />
    );
};
